import { Spacing } from '@persona-id/design-tokens';
import { ChevronLeftIcon } from '@persona-id/design-tokens/icons';
import { VFC } from 'react';
import styled from 'styled-components';

import OptionCard from 'dashboard/components/WorkflowControlPanel/TriggerConfigEvent/OptionCard';
import { ProductFeatureName } from 'dashboard/models/organization';
import Button from 'design-system/components/Button';
import Spacer from 'design-system/components/Spacer';
import { EventType } from 'lib/constants/events';
import useFeatureFlag from 'lib/hooks/useFeatureFlag';
import useProductFeature from 'lib/hooks/useProductFeature';

const CardWrapper = styled.div`
  padding-top: ${Spacing[2]};
  padding-bottom: ${Spacing[2]};
`;

interface ChangeTriggerProps {
  initialEventType: EventType;
  handleSelectTriggerObjectType: (value: EventType) => void;
}

const ChangeTrigger: VFC<ChangeTriggerProps> = ({
  initialEventType,
  handleSelectTriggerObjectType,
}) => {
  const enableAccountEvent = useFeatureFlag('dashboard:workflows-account-event');
  const enableAccountUpdatedFieldsEvent = useFeatureFlag(
    'dashboard:accounts-emit-account-updated-field-events-v2',
  );
  const enableTransactionEvent = useProductFeature(ProductFeatureName.TransactionsDashboard);
  const eventTypeOptions = [
    ...(enableAccountEvent || enableAccountUpdatedFieldsEvent ? [EventType.Account] : []),
    EventType.Inquiry,
    EventType.Report,
    EventType.Case,
    EventType.CaseMessage,
    ...(enableTransactionEvent ? [EventType.Transaction] : []),
    EventType.SAR,
  ];

  const handleBackClick = () => {
    handleSelectTriggerObjectType(initialEventType);
  };

  const chooseEventType = (type: EventType) => {
    handleSelectTriggerObjectType(type);
  };

  return (
    <>
      <Button width='auto' onClick={handleBackClick} variant='basic'>
        <ChevronLeftIcon />
        Back
      </Button>
      <Spacer />
      <h4>Change Trigger</h4>
      <Spacer height={1.5} />
      {eventTypeOptions.map((value: EventType) => {
        return (
          <CardWrapper key={value} data-test={`workflow-change-trigger__${value}`}>
            <OptionCard
              type={value}
              active={initialEventType === value}
              chooseEventType={chooseEventType}
            />
          </CardWrapper>
        );
      })}
    </>
  );
};

export default ChangeTrigger;
